
	import Vue from "vue"
	import Component from "vue-class-component"
	import { Prop, Emit } from "vue-property-decorator"
	import { Message } from "store/messages/types"

	@Component
	export default class MessageList extends Vue {
		@Prop({type: Object}) value!: Message | null
		@Prop({required: true, type: Array}) messages!: Array<Message>

		@Emit("input")
		selectMessage(message: Message | null): Message | null {
			return message
		}
	}
